import $ from 'jquery';

const KEYS = {
    TAB: 9,
    ESC: 27,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    ENTER: 13,
    SPACE: 32,
    END: 35,
    HOME: 36,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    DEL: 46
};

const DEFAULT_PAGE_SIZE = 8;

const handleEnterAndSpace = (callback) => {
    return (e) => {
        if (e.keyCode === KEYS.ENTER || e.keyCode === KEYS.SPACE) {
            e.preventDefault(); // Stop scrolling down screen in the case of space button
            callback(e);
        }
    };
};

const handleEnter = (callback, preventDefault) => {
    return (e) => {
        if (e.keyCode === KEYS.ENTER) {
            if (preventDefault) {
                e.preventDefault();
            }
            callback(e);
        }
    };
};

const acceptKeypress = (e) => {
    e.stopPropagation();
    e.preventDefault();
    return true;
};

const keyCodeIsToMoveUpOrDown = (keyCode) => {
    return (
        keyCode === KEYS.ARROW_DOWN ||
        keyCode === KEYS.ARROW_UP ||
        keyCode === KEYS.HOME ||
        keyCode === KEYS.END ||
        keyCode === KEYS.PAGE_UP ||
        keyCode === KEYS.PAGE_DOWN
    );
};

// Calculates a new position in a list due to a keypress that changes position (up / down arrows, page up/down, etc)
// If the keypress is not relevant, or doesn't affect the list, then return undefined.
const changedPositionDueToKeypress = (event, currentPosition, numberOfEntries, pageSize = DEFAULT_PAGE_SIZE) => {
    let newIndex = undefined;
    let keyCode = event.keyCode;

    if (currentPosition < numberOfEntries - 1) {
        switch (keyCode) {
            case KEYS.ARROW_DOWN:
                newIndex = currentPosition + 1;
                break;
            case KEYS.PAGE_DOWN:
                newIndex = Math.min(currentPosition + pageSize, numberOfEntries - 1);
                break;
            case KEYS.END:
                newIndex = numberOfEntries - 1;
                break;
            default:
        }
    }

    if (currentPosition > 0) {
        switch (keyCode) {
            case KEYS.ARROW_UP:
                newIndex = currentPosition - 1;
                break;
            case KEYS.PAGE_UP:
                newIndex = Math.max(currentPosition - pageSize, 0);
                break;
            case KEYS.HOME:
                newIndex = 0;
                break;
            default:
        }
    }

    return newIndex;
};

const focusOnFirstItemInSelector = (selector) => {
    $(selector).first().find(':focusable').first().focus();
};

export {
    handleEnterAndSpace,
    handleEnter,
    changedPositionDueToKeypress,
    acceptKeypress,
    keyCodeIsToMoveUpOrDown,
    KEYS,
    focusOnFirstItemInSelector
};
